import React, { useMemo, useState } from "react";
import { Card, ListGroup, Row, Col, Button } from "react-bootstrap";
import { Location } from "../../types/Types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHammer, faPlane, faHotel, faUmbrellaBeach, faGraduationCap, faPencilAlt, faTrain } from '@fortawesome/free-solid-svg-icons';
import { getCountryFlag } from "../../util/Util";
import { usePagination } from "../../../hooks/usePagination";
import PaginationControls from "../../shared/PaginationControls";

interface Props {
    locations: Location[];
}

function AdminMissingOpeningDate(props: Props) {
    const [hasLoaded, setHasLoaded] = useState<boolean>(false);
    const { pageStart, pageEnd, pageLeft, pageRight, getPaginatedItems } = usePagination<Location>({ pageSize: 50 });

    const filteredLocations = useMemo(() => {
        const locs = props.locations.filter((location) => {
            return !location.openingDate;
        });

        locs.sort((a, b) => a.name.localeCompare(b.name));

        return locs;
    }, [props.locations]);

    const showData = () => {
        setHasLoaded(true);
    };

    const paginatedLocations = getPaginatedItems(filteredLocations);

    return (
        <>
            <Card className={"mb-3"}>
	                <Card.Header>
	                    <div className="d-flex justify-content-between align-items-center">
	                        <div>
	                            <div><b>Missing Opening Date</b></div>
	                            <small className="text-muted">Total: {filteredLocations.length} pubs</small>
	                        </div>
                            {!hasLoaded && (
                                <Button size="sm" onClick={showData}>Show Data</Button>
                            )}
	                    </div>
	                </Card.Header>
                    {hasLoaded && (
	                <Card.Body style={{ padding: 0 }}>
	                    {filteredLocations.length === 0 ? (
	                        <div className="text-center p-3">No pubs missing opening date</div>
                    ) : (
                        <ListGroup variant="flush">
                            {paginatedLocations.map((location) => (
                                <ListGroup.Item key={location.id} className="admin-pub-data-list-item">
                                    <Row className="align-middle flex-nowrap no-gutters">
                                        <Col className="d-flex flex-column align-items-start justify-content-center text-truncate">
                                            <div>
                                                <Link to={`/location/${location.id}/comments`} className={"p-0"}>
                                                    <div className={"location-tag"}>{location.name}</div>
                                                </Link>
                                                {location.airport && <small className="text-truncate">
                                                    <FontAwesomeIcon className="ml-1 animated zoomIn icon-plane" icon={faPlane} />
                                                </small>}
                                                {location.hotel && <small className="text-truncate">
                                                    <FontAwesomeIcon className="ml-1 animated zoomIn icon-hotel" icon={faHotel} />
                                                </small>}
                                                {location.holidayPark && <small className="text-truncate">
                                                    <FontAwesomeIcon className="ml-1 animated zoomIn icon-holidaypark" icon={faUmbrellaBeach} />
                                                </small>}
                                                {location.isUniversity && <small className="text-truncate">
                                                    <FontAwesomeIcon className="ml-1 animated zoomIn icon-university" icon={faGraduationCap} />
                                                </small>}
                                                {location.trainStation && <small className="text-truncate">
                                                    <FontAwesomeIcon className="ml-1 animated zoomIn icon-train" icon={faTrain} />
                                                </small>}
                                                {location.pubIsTemporaryClosed && <small className="text-truncate">
                                                    <FontAwesomeIcon className="ml-1 animated zoomIn icon-temporary" icon={faHammer} />
                                                </small>}
                                                <Link to={`/admin/${location.id}`}>
                                                    <FontAwesomeIcon className="ml-2 animated zoomIn icon-pen cursor-pointer" icon={faPencilAlt} />
                                                </Link>
                                            </div>
                                            <div className="ml-1">
                                                <small className="text-truncate">
                                                    <div className="d-inline-block" style={{ marginRight: "0.3em" }}>{getCountryFlag(location.country || '')}</div>
                                                    <div className="d-inline-block">{location.address}</div>
                                                </small>
                                            </div>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Card.Body>
                    )}
                {hasLoaded && filteredLocations.length > 0 && (
                    <Card.Footer>
                        <PaginationControls
                            pageStart={pageStart}
                            pageEnd={pageEnd}
                            totalItems={filteredLocations.length}
                            onPageLeft={pageLeft}
                            onPageRight={() => pageRight(filteredLocations.length)}
                        />
                    </Card.Footer>
                )}
            </Card>
        </>
    );
}

export default AdminMissingOpeningDate;
